<hs-no-focused-aggregate [content]="smartSuspense"> </hs-no-focused-aggregate>

<ng-template #smartSuspense>
  <smart-suspense
    [source]="source"
    [panelKey]="panelKey"
    [account]="account"
    [savedViewService]="savedViewService"
    [filterGroupService]="filterGroupService"
    [state]="state"
    [setState]="setComponentState"
    [attr.commentary-access]="commentaryAccess"
    [commentaryFocus]="commentaryFocus"
  ></smart-suspense>
</ng-template>
